import { Card, Icon, Layout, Text, TextLink } from '@oneaudi/unified-web-alpha-components';
import { useI18n } from '~/app/i18n/i18n';
import {
	ListItemStyle,
	ListStyle,
	TyreLabelStyle,
} from '~/app/pages/configurator/components/dialogs/car-matching-results-dialog/styles/tyre-label-styles';
import { ConfiguredCarFeature } from '~/graphql/__generated__/graphql';
import { htmlToText } from 'html-to-text';

export function EuTyreLabel({ tyreLabels }: { tyreLabels: NonNullable<ConfiguredCarFeature['tyreLabels']> }) {
	const { i18n } = useI18n();
	const tireLabelUrl = i18n('ngc.dialogs.euTyreLabel.linkURL');

	return (
		<TyreLabelStyle>
			{tireLabelUrl && (
				<Layout direction={'column'} rowGap="10px">
					<Text className="link-text" variant={{ type: 'copy', order: '1', style: 'bold' }}>
						{i18n('ngc.dialogs.euTyreLabel.linkText')}
					</Text>

					<TextLink
						icon="external-link"
						iconPosition="trailing"
						variant="standalone"
						href={tireLabelUrl}
						size="sm"
						target="_blank">
						{i18n('ngc.dialogs.euTyreLabel.linkText')}
					</TextLink>
				</Layout>
			)}
			{}
			<Card className="disclaimer">
				<Icon name={'info-circle'} size="s" />
				<Text variant={{ type: 'copy', order: '1', style: 'normal' }}>
					{i18n('ngc.dialogs.euTyreLabel.disclaimer')}
				</Text>
			</Card>

			{tyreLabels.length > 0 && (
				<ListStyle>
					{tyreLabels.map((label) => (
						<ListItemStyle key={label?.productSheetUrl}>
							<figure role="group">
								<Card className="card">
									{label?.tyreLabelUrl && (
										<img
											tabIndex={0}
											src={label.tyreLabelUrl}
											alt={htmlToText(i18n('ngc.dialogs.euTyreLabel.description'))}
										/>
									)}
								</Card>
								{label?.productSheetUrl && (
									<figcaption>
										<TextLink
											icon="external-link"
											iconPosition="trailing"
											size="sm"
											variant="standalone"
											href={label.productSheetUrl}
											target="_blank">
											{i18n('ngc.actions.productDataSheet')}
										</TextLink>
									</figcaption>
								)}
							</figure>
						</ListItemStyle>
					))}
				</ListStyle>
			)}
		</TyreLabelStyle>
	);
}
